import React, { useEffect, useState } from 'react';
import api from '../api';
import * as XLSX from 'xlsx';
import '../styles/relatorioMaisOfertados.scss';

const RelatorioMaisOfertados = () => {
    const [relatorioMaisOfertados, setRelatorioMaisOfertados] = useState([]);
    const [filteredCursos, setFilteredCursos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const cursosPorPagina = 10;

    useEffect(() => {
        const fetchRelatorioMaisOfertados = async () => {
            try {
                const response = await api.get('/relatorio/cursos');
                const cursosMaisOfertados = response.data.cursosMaisOfertados.map(([curso, quantidade]) => ({
                    'CURSO OFERTADO': curso,
                    'QUANTIDADE': quantidade,
                }));

                setRelatorioMaisOfertados(cursosMaisOfertados);
                setFilteredCursos(cursosMaisOfertados);
            } catch (error) {
                console.error('Erro ao buscar relatório de cursos mais ofertados:', error);
            }
        };

        fetchRelatorioMaisOfertados();
    }, []);

    useEffect(() => {
        const results = relatorioMaisOfertados.filter(curso =>
            curso['CURSO OFERTADO'].toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredCursos(results);
        setCurrentPage(1);
    }, [searchTerm, relatorioMaisOfertados]);

    const downloadExcel = () => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(filteredCursos);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Rel de Cursos Mais Ofertados');

        const now = new Date();
        const formattedDate = now.toLocaleString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).replace(/\//g, '-').replace(',', '');

        const fileName = `RelatorioMaisOfertados—${formattedDate}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    };

    const indexOfLastCurso = currentPage * cursosPorPagina;
    const indexOfFirstCurso = indexOfLastCurso - cursosPorPagina;
    const currentCursos = filteredCursos.slice(indexOfFirstCurso, indexOfLastCurso);
    const totalPages = Math.ceil(filteredCursos.length / cursosPorPagina);

    const getPaginationButtons = () => {
        const buttons = [];
        buttons.push(1);

        if (currentPage > 3) {
            buttons.push("...");
        }

        for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
            buttons.push(i);
        }

        if (currentPage < totalPages - 2) {
            buttons.push("...");
        }

        if (totalPages > 1) {
            buttons.push(totalPages);
        }

        return buttons;
    };

    return (
        <div>
            <h1>Relatório de Cursos Mais Ofertados</h1>
            <input
                type="text"
                placeholder="Filtrar por nome do curso"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button className='btn-download-excel' onClick={downloadExcel}>Download Excel</button>
            <table>
                <thead>
                    <tr>
                        <th>Curso Ofertado</th>
                        <th>Quantidade</th>
                    </tr>
                </thead>
                <tbody>
                    {currentCursos.map((curso, index) => (
                        <tr key={index}>
                            <td>{curso['CURSO OFERTADO']}</td>
                            <td>{curso['QUANTIDADE']}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination">
                {getPaginationButtons().map((page, index) => (
                    <button key={index} onClick={() => {
                        if (page !== "...") {
                            setCurrentPage(page);
                        }
                    }} disabled={page === "..."}>{page}</button>
                ))}
            </div>
        </div>
    );
};

export default RelatorioMaisOfertados;
